{
  "Featured news": "Featured news",
  "post-load-error": "Something went wrong. <0>Click here</0> to try again.",
  "Create post": "Post",
  "My team": "My team",
  "General": "Start",
  "Something went wrong": "Something went wrong",
  "Channels": "Channels",
  "Team Channels": "Team Channels",
  "Select a team channel": "Select a team",
  "No action available": "No action available",
  "New channel": "Create new Channel",
  "Channel path": "Channel path",
  "Channel alias": "Channel name",
  "Channel description": "Description",
  "Add channel": "Save",
  "Cancel": "Cancel",
  "Update channel": "Edit Channel",
  "Could not update section:": "Could not update section:",
  "Ask a question": "Create shared reflection",
  "Write a post": "Create post",
  "Create new post": "Create new post",
  "Edit": "Edit",
  "Post": "Create",
  "New reflection": "New reflection",
  "No posts yet.": "No posts",
  "No reflections yet.": "No reflections",
  "Show more": "Show more",
  "Invalid time format: YYYY-MM-DD HH:mm": "Invalid time format: YYYY-MM-DD HH:mm",
  "[deleted]": "[deleted]",
  "Publishing: {{date}}": "Publishing: {{date}}",
  "Text (required)": "Text (required)",
  "Title": "Title (required)",
  "Update": "Update",
  "Copy code": "Copy code",
  "Delete": "Delete",
  "Are you sure you want to delete this post?": "Are you sure you want to delete this post?",
  "Are you sure you want to delete this reflection?": "Are you sure you want to delete this reflection?",
  "post-error": "Something went wrong. Try again.",
  "Write an answer...": "Write a comment",
  "Sticky": "Pin",
  "Un-sticky": "Unpin",
  "Make sticky": "Pin",
  "admin": "admin",
  "member": "member",
  "moderator": "moderator",
  "Write a comment": "Write a comment",
  "Reply": "Reply",
  "Comment": "Comment",
  "Comment_plural": "Comments",
  "Send notification": "Send notification",
  "notification-verb": "reacted to",
  "notification-verb_LIKE": "liked",
  "notification-verb_REPLY": "commented on",
  "notification-post": "<0>{{name}}</0> {{verb}} your post <1>{{title}}</1> in the Channel <2>{{channel}}</2>",
  "notification-post_product": "<0>{{name}}</0> {{verb}} your post <1>{{title}}</1> in the Channel <2>{{channel}}</2> in {{productTitle}}",
  "notification-reflection": "<0>{{name}}</0> {{verb}} your reflection <1>{{title}}</1> in {{productTitle}}",
  "Are you sure that you want to clear all notifications?": "Are you sure that you want to clear all notifications?",
  "notification-other": "+1 other",
  "notification-other_plural": "+{{count}} others"
}
